<template>
  <div>
    <Return title="信息登记表" :back="false" />
    <div class="each">
      <div class="them">1. 信息登记表详情</div>
      <div v-if="certUrl">
        <div class="showCert">
          <el-image
            class="preview"
            :src="certUrl"
            :preview-src-list="certPreviewUrl"
          >
          </el-image>
          <a :href="certUrl" target="_blank" class="load">下载登记表</a>
        </div>
        <div @click="upRecordTable()" class="UploadBtn">更新登记表</div>
      </div>
      <div v-else class="empty">暂无</div>
    </div>
    <div class="each" v-if="badArr && badArr.length">
      <div class="them">2. 不良行为记录</div>
      <div class="cont">
        <div class="it" v-for="(item, index) in badArr" :key="index">
          <div class="text">{{ item.content }}</div>
          <a v-if="item.file" :href="item.file" target="_blank" class="check"
            >查看文件</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Return from "@/components/record/Return";
import { bad, newCertificate, refreshCert } from "@/api/company.js";

export default {
  name: "recordTableIndex",
  components: {
    Return,
  },
  created() {
    this.init();
    this.cert();
  },
  data() {
    return {
      badArr: [], //不良行为记录
      certUrl: "", //证书地址
      certPreviewUrl: [], //证书预览地址
    };
  },
  methods: {
    async init() {
      const res = await bad();
      this.badArr = res;
    },
    async upRecordTable() {
      const res = await refreshCert();
      if (res && res.url) {
        this.certUrl = res.url;
        this.$message.success("更新成功！");
      }
      // console.log(res);
    },
    async cert() {
      const res = await newCertificate();
      this.certUrl = res.url;
      this.certPreviewUrl.push(this.certUrl);
      // console.log(this.certUrl, "this.certUrl");
    },
  },
};
</script>

<style lang="less" scoped>
.each {
  background: #ffffff;
  border-radius: 2px;
  padding: 0 20px 30px;
  display: flex;
  align-items: flex-start;
  margin-top: 20px;

  .empty {
    font-size: 12px;
    color: #333333;
    margin-top: 30px;
  }

  .them {
    min-width: 190px;
    font-size: 12px;
    font-weight: 700;
    color: #333333;
    margin-top: 30px;
  }

  .showCert {
    display: flex;
    text-align: center;
  }

  .UploadBtn {
    margin-top: 5px;
    width: 150px;
    height: 32px;
    background: #4379f6;
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #ffffff;
    justify-content: center;
    margin-left: 5px;
    cursor: pointer;
  }

  .preview {
    width: 159px;
    height: 219px;
    display: block;
    margin-top: 30px;
  }

  .load {
    font-size: 12px;
    color: #4379f6;
    margin-left: 12px;
    margin-top: 231px;
  }
}

.cont {
  flex-direction: row;

  .it {
    margin-top: 30px;

    .text {
      font-size: 12px;
      color: #333333;
    }

    .check {
      font-size: 12px;
      color: #4379f6;
      margin-top: 7px;
      cursor: pointer;
    }
  }
}
</style>
